import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useWikiSpaces() {
	/** Query */
	const query = useQuery({
		queryKey: ["wiki-spaces"],
		queryFn: async () => {
			const response = await client.wiki.spaces.root.$get();
			const data = await responseHandler(response);
			return data.wikiSpaces;
		},
	});

	/** Return */
	return { ...query, wikiSpaces: query.data };
}
